import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { NavLink } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";

import { appRoutes } from "routes";
import { useUsers } from "hooks";
import logoHorizontal from "assets/images/common/logo-horizontal.png";
import UserPresenter from "presenters/UserPresenter";

import useStyles from "./useStyles";

const MobileHeader = (props) => {
  const classes = useStyles();
  const { onDrawerOpen } = props;
  const { currentUser } = useUsers();

  return (
    <div className={classes.root}>
      <NavLink to={appRoutes.rootPath()} className={classes.left}>
        <img src={logoHorizontal} alt="JibJab" className={classes.logo} />
      </NavLink>
      <div className={classes.main}>
        <NavLink color="inherit" aria-label="search" to={appRoutes.searchPath()}>
          <SearchIcon className={classes.searchIcon} />
        </NavLink>
        {!UserPresenter.isRegistered(currentUser) && (
          <NavLink to={appRoutes.signUpPath()} className={classes.buttonLink}>
            <span>Sign Up</span>
          </NavLink>
        )}
        {UserPresenter.isRegistered(currentUser) && !UserPresenter.isPaid(currentUser) && (
          <NavLink to={appRoutes.paymentPath()} className={classes.buttonLink}>
            <span>Upgrade</span>
          </NavLink>
        )}
        <IconButton
          className={classes.menuIconButton}
          disableRipple={false}
          disableFocusRipple={false}
          color="inherit"
          aria-label="menu"
          onClick={onDrawerOpen}
        >
          <MenuIcon className={classes.menuIcon} />
        </IconButton>
      </div>
    </div>
  );
};

MobileHeader.propTypes = {
  onDrawerOpen: PropTypes.func.isRequired,
};

export default MobileHeader;
